module.exports = __webpack_public_path__ + "static/Coffee2-d4f1719dfb54ffe0769fda51721a0ad0.png";